module.exports = __webpack_public_path__ + "static/media/icon-office.e8d67251.png";